import { Component, OnInit } from '@angular/core';
import { AdminServicesService } from '../admin-services.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/user.service';

@Component({
  selector: 'app-login-admin',
  templateUrl: './login-admin.component.html',
  styleUrls: ['./login-admin.component.css']
})
export class LoginAdminComponent implements OnInit {

  public citizenLocalStorage:any;

  public username: any;
  public password: any;
  public dropdown: any = [];
  fieldTextType: boolean;
  role: any;
  constructor(public admin: AdminServicesService,
    public router: Router,
    public toastr: ToastrService,
    public use: UserService) { }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  ngOnInit(): void {
    this.admin.dropdownScope().subscribe((res: any) => {
      if (res.code === 200) {
        this.dropdown = res.data;
      } else {
        console.log("error")
      }
    }, (err) => {
      console.log(err);
    })
  }

  login() {

    this.citizenLocalStorage=localStorage.getItem('data');

    if (!this.username) {
      return this.toastr.error("User Name is Empty");
    } else if (!this.password) {
      return this.toastr.error("Password is Empty");
    } else if (!this.role) {
      return this.toastr.error("User Type is Empty");
    }else if(this.citizenLocalStorage){
      return this.toastr.error("Please Logout Citizen Portal to access Admin Portal");
    } else {
      let obj = {
        "userName": this.username,
        "password": this.password,
        "userType": this.role
      }
      this.admin.loginAdmin(obj).subscribe((res: any) => {
        if (res.code === 200) {
          // localStorage.clear();
          localStorage.setItem('userDetails', JSON.stringify(res.data[0]));
          localStorage.setItem('accessToken', res.data[0].accesstoken);
          localStorage.setItem('refreshToken', res.data[0].refreshtoken);
          // console.log('$$$$$$$$$$$$$$$$$',res.data[0].accesstoken)
          this.use.loggedIn =true;  // for admin dashboard url, after cmg from citizen website url 
          this.toastr.success("Login Successful");
          this.router.navigate(['dashboardmain-admin']);
        } else if (res.code === 402) {
          this.toastr.error(res.message);
        }
        else {
          this.toastr.error(res.message);
        }
      }, (err) => {
        console.log(err);
      })
    }
  }
}
